import React from "react";

const CustomerSlider = () => {
  const partners = [
    { src: "/assets/images/bluewod.webp", label: "Bluewood" },
    { src: "/assets/images/excel.jpeg", label: "Excel" },
    { src: "/assets/images/stas.webp", label: "Stass" },
    { src: "/assets/images/stag.webp", label: "Stag" },
    { src: "/assets/images/uni.jpeg", label: "Universal" },
  ];

  return (
    <div className="w-full px-4 bg-white">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&display=swap');

        .customers-section {
          font-family: 'DM Sans', sans-serif;
        }

        .customers-title {
          text-align: center;
          font-size: 1.75rem;
          font-weight: 700;
          color: #1a1a2e;
          margin-bottom: 8px;
          letter-spacing: -0.3px;
        }

        .customers-subtitle {
          text-align: center;
          font-size: 0.9rem;
          color: #2b7de9;
          font-weight: 500;
          margin-bottom: 40px;
        }

        .scroll-outer {
          overflow: hidden;
          position: relative;
          width: 100%;
        }

        .scroll-outer::before,
        .scroll-outer::after {
          content: '';
          position: absolute;
          top: 0;
          bottom: 0;
          width: 80px;
          z-index: 2;
          pointer-events: none;
        }
        .scroll-outer::before {
          left: 0;
          background: linear-gradient(to right, #ffffff, transparent);
        }
        .scroll-outer::after {
          right: 0;
          background: linear-gradient(to left, #ffffff, transparent);
        }

        .track {
          display: flex;
          width: max-content;
          animation: scroll 18s linear infinite;
        }

        .track:hover {
          animation-play-state: paused;
        }

        @keyframes scroll {
          0%   { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }

        .card {
          min-width: 180px;
          margin: 0 14px;
          background: #f9f7f2;
          border: 1px solid #ede8de;
          border-radius: 12px;
          padding: 20px 16px 14px;
          display: flex;
          flex-direction: column;
          align-items: center;
          transition: box-shadow 0.2s ease, transform 0.2s ease, background 0.2s ease;
          cursor: default;
        }

        .card:hover {
          box-shadow: 0 6px 20px rgba(0,0,0,0.08);
          transform: translateY(-2px);
          background: #ffffff;
        }

        .img-box {
          width: 110px;
          height: 72px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #ffffff;
          border: 1px solid #ede8de;
          border-radius: 8px;
          padding: 10px;
        }

        .img-box img {
          max-width: 100%;
          max-height: 100%;
          object-fit: contain;
        }

        .label {
          font-size: 0.72rem;
          margin-top: 10px;
          font-weight: 600;
          color: #888;
          letter-spacing: 0.3px;
          text-transform: uppercase;
        }
      `}</style>

      <div className="customers-section ">
        <h2 className="customers-title">Our Valuable Customers</h2>
        <p className="customers-subtitle">Trusted by businesses across India</p>

        <div className="scroll-outer">
          <div className="track">
            {/* ORIGINAL */}
            {partners.map((p, i) => (
              <div key={i} className="card">
                <div className="img-box">
                  <img src={p.src} alt={p.label} />
                </div>
                <span className="label">{p.label}</span>
              </div>
            ))}

            {/* DUPLICATE */}
            {partners.map((p, i) => (
              <div key={`dup-${i}`} className="card">
                <div className="img-box">
                  <img src={p.src} alt={p.label} />
                </div>
                <span className="label">{p.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerSlider;